import { FC, useEffect, useRef, useState } from 'react';
import './CustomCalendar.scss';
import dayjs, { Dayjs } from 'dayjs';
import { DateCalendar, LocalizationProvider, PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import images from '../../assets/images';
import { useAppSelector } from '../../redux/app/hooks';
import { SCHOOL_ADMIN } from '../../utils/constants';
import { CalendarDataType } from '../../pages/Calendar/Calendar';
import { Tooltip } from '@mui/material';
import moment from 'moment';

type CustomCalendarType = {
  value: Dayjs | null;
  setValue: (val: Dayjs) => void;
  favouritesData:CalendarDataType[];
  allCalendarData: CalendarDataType[]|undefined;
  setOpen: (val: boolean) => void;
  handleApiCall: (filterDate: Dayjs, isFilter: boolean, isFavourites: boolean) => void;
  open: boolean;
  isMobile:boolean
  favouriteIsOpen:boolean;
  setfavouriteIsOpen: (val: boolean) => void;
  handleClearFilter:()=>void;
}

// Set Monday as start the week
dayjs.locale({
  ...dayjs.Ls['en'],
  weekStart: 1,
});

const CustomCalendarHeader: FC<{ month: number }> = ({ month }) => {
  const days = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

  return (
    <div className="MuiDayCalendarCustom-header">
      <div className="MuiTypography-root MuiTypography-caption MuiDayCalendar-weekNumberLabel">{String(month).padStart(2, '0')}</div>
      {days.map((day, index) => (
        <div key={index} className="MuiTypography-root MuiTypography-caption MuiDayCalendar-weekDayLabel">{day}</div>
      ))}
    </div>
  );
};


const CustomCalendar: FC<CustomCalendarType> = ({ value, setValue, favouritesData,allCalendarData, setOpen, handleApiCall, open ,isMobile,favouriteIsOpen,setfavouriteIsOpen,handleClearFilter}) => {
  const [year, setYear] = useState(dayjs().year());
  const { BackIconGray,ActiveCalenderComponentIcon,InActiveFavouriteIcon,InActiveCalenderComponentIcon,
    ActiveFavouriteIcon
   } = images;
  const role = useAppSelector((state) => state.auth.role);
  const [isTitleOverflow,setIsTitleOverflow] = useState<boolean[]>([]);
  const titleRefs = useRef<Array<HTMLSpanElement | null>>([]);
  const [enableFilter, setEnableFilter] = useState<boolean>(false);
  const [calendarIsOpen,setCalendarIsOpen] = useState<boolean>(false);
  // const [favouriteIsOpen,setfavouriteIsOpen] = useState<boolean>(false);


  const handlePrevYear = () => {
    const newYear = year - 1;
    const newDate = dayjs(value).year(newYear);
    if (newDate) {
      setValue(newDate.isAfter(dayjs()) ? newDate : dayjs());
      setYear(newDate.isAfter(dayjs()) ? newYear : dayjs().year());
      setEnableFilter(true);
    }
  };

  const handleNextYear = () => {
    const newYear = year + 1;
    const newDate = dayjs(value).year(newYear);
    if (newDate) {
      setValue(newDate.isAfter(dayjs()) ? newDate : dayjs());
      setYear(newDate.isAfter(dayjs()) ? newYear : dayjs().year());
      setEnableFilter(true);
    }
  };

  const months = [
    'JAN', 'FEB', 'MAR', 'APR',
    'MAY', 'JUN', 'JUL', 'AUG',
    'SEP', 'OCT', 'NOV', 'DEC'
  ];

  const handleMonthClick = (monthIndex: number) => {
    const newDate = dayjs(value).year(year).month(monthIndex).startOf('month');
    if (newDate) {
      const newValue = dayjs(newDate).isAfter(dayjs()) ? newDate : dayjs();
      setValue(newValue);
      setEnableFilter(true);
    }
  };

  // Check if the title is overflowing
  const checkOverflow = () => {
    const overflowStatus = titleRefs.current.map((ref) => ref ? ref.scrollWidth > ref.clientWidth : false);
    setIsTitleOverflow(overflowStatus);
  };

  // Use useEffect to run checkOverflow after render
  useEffect(() => {
    checkOverflow();

    const handleResize = () => {
      checkOverflow();
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [favouritesData]);

  const handleDateChange = (newValue: Dayjs) => {
    if (!value?.isSame(newValue) || enableFilter) {
      setValue(newValue);
      setEnableFilter(false);
      handleApiCall(newValue, true, false);
    }
  }

  // Custom renderDay function to highlight scheduled events
const renderDay = (
  day: Dayjs,
  pickersDayProps: PickersDayProps<Dayjs>
) => {
  const isScheduledEvent = allCalendarData?.some(event => dayjs(event.eDate).isSame(day, 'day'));
  const isCurrentDate = dayjs().isSame(day, 'day');

  return (
    <PickersDay
      {...pickersDayProps}
      className={`custom-day ${isScheduledEvent ? 'scheduled-event' : ''} ${isCurrentDate ? 'current-day' : ''}`}
    />
  );
};

  return (
    <>
      <div className={`calendarHeader ${ role === SCHOOL_ADMIN && 'AdminCalendarHeader' }`}>
        <div className ={`CalendarMobileDateContainer `} >
        <div className='dateContainer' style={{visibility: favouriteIsOpen?"hidden":"visible"}}>
            <div className='day'>{`${dayjs(value).format('dddd')}`}</div>
            <div className='dot'>.</div>
            <div className='date'>{isMobile?`${dayjs(value).format('DD MMMM YY')}`:`${dayjs(value).format('DD MMMM YYYY')}`}</div>
          </div>
          {isMobile && 
            <div className='CalendarMobileIconContainer'>
              {!favouriteIsOpen && <img className="calendarIcon" alt="calendarIcon" src={ !calendarIsOpen ? InActiveCalenderComponentIcon:ActiveCalenderComponentIcon} onClick={()=>{setCalendarIsOpen(!calendarIsOpen);
                setOpen(false);
              }}/>}
              {role !== SCHOOL_ADMIN && <img className="calendarIcon" alt="calendarIcon" src={ !favouriteIsOpen?InActiveFavouriteIcon:ActiveFavouriteIcon} onClick={()=>{handleClearFilter();setfavouriteIsOpen(!favouriteIsOpen);setCalendarIsOpen(false);setOpen(false)}}/>}
            </div>
          }
          </div>
          
          {
          (!isMobile || calendarIsOpen) 
          
          &&<div className="calendarMonths">
            <div className={(year > dayjs().year()) ? "iconContainer" : "hideIconContainer"} onClick={handlePrevYear}>
              <img className="prevIcon" src={BackIconGray} alt="Previous Year" />
            </div>
            <div className='monthsContainer'>
              {months.map((month, index) => {
                const isPreviousDate = (year === dayjs().year() && index < dayjs().month());
                return (
                  <div key={index} className={`${isPreviousDate ? "defaultCursor" : ""} ${ index === dayjs(value).month() ? 'active-calendar-month' : "calendar-month"}`} onClick={() => !isPreviousDate ? handleMonthClick(index) : undefined }>
                    {month}
                  </div>
                )
              })}
            </div>
            <div className='iconContainer' onClick={handleNextYear}>
              <img className='nextIcon' src={BackIconGray} alt='back Icon'/>
            </div>
          </div>}
        </div>
        {(!isMobile  || calendarIsOpen ) && 
        <div className='CalendarWidgetOuterDiv'>
          <div className='calendar'>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateCalendar
              value={value}
              onChange={(newValue) => handleDateChange(newValue)}
              displayWeekNumber
              showDaysOutsideCurrentMonth
              disablePast
              slots={{
                calendarHeader: () => <CustomCalendarHeader month={dayjs(value).month() + 1} />,
                day: (pickersDayProps) => renderDay(pickersDayProps.day, pickersDayProps),
              }}
            />
          </LocalizationProvider>
          </div>
        <div><button type="button" onClick={() => setOpen(true)} className={role === SCHOOL_ADMIN ? (`AddEventButton ${ open ? "defaultCursorForBtn" : "" }`):'HideAddEventButton'}>Add Event</button></div>

        </div>
        }
       {(!isMobile) && <div className={favouritesData?.length > 0 ? 'favouritesContainer':'noDataForFavourites'}>
        {(favouritesData?.length > 0 && role !== SCHOOL_ADMIN) ? (favouritesData.map((val: CalendarDataType, index: number) => {
          return (
            <div className='FavouriteData'>
              <div className='favouriteDetail'>
                <span className='favouriteDate'>{moment(val?.eDate).format('DD.MM.YY')}</span>
                <Tooltip title={<span>{val.eOriginalTitle}</span>}
                disableHoverListener={!isTitleOverflow[index]} 
                placement="top">
                <span className='favouriteTitle' 
                ref={(el) => (titleRefs.current[index] = el)}
                >
                  {val?.eOriginalTitle}
                </span>
                </Tooltip>
              </div>
              <div className='favouriteIcon'/>
            </div>
          )
        })) : (
          <div className='noDataFoundStyle'></div>
        )}
      </div>}
    </>
  );
}

export default CustomCalendar;
